import { useState, useEffect } from "react";
import api from "./api";
import { useUserSuperEmpresa } from "../Context/AuthContext";

export const useEgresoRME = () => {
  const { Token } = useUserSuperEmpresa();

  const getEgresos = async (
    mes = "",
    anio = "",
    tipoFecha = "date",
     categoria =""
) => {
    try {
        const { data } = await api.get("/expenses", {
           
            params: {
                mes,
                anio,
                tipo_fecha: tipoFecha,
                 categoria
            }
        });

        return data;

    } catch (error) {
        console.error(error);
        throw (
            error.response?.data?.message ||
            "Error al cargar egresos"
        );
    }
};

  // 📌 Obtener un egreso por ID
  const getEgresoById = async (id) => {
    try {
      const { data } = await api.get(`/expenses/${id}`, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      return data;
    } catch (error) {
      console.error("Error al traer un egreso:", error);
      throw error.response?.data?.message || "Error al cargar egreso";
    }
  };

  // 📌 Crear
  const crearEgresoRME = async (nuevoEgreso) => {
    try {
      const { data } = await api.post(`/crear/expenses`, nuevoEgreso, {
        headers: { Authorization: `Bearer ${Token}`,  "Content-Type": "multipart/form-data", },
      });
      return data;
    } catch (error) {
      console.error("💥 Error al crear egreso:", error);
      throw error.response?.data?.message || "Error al crear egreso";
    }
  };

 const editarEgresoRME = async (id, formData) => {
  try {
    const { data } = await api.post(`/expenses/${id}`, formData);
    return data;
  } catch (error) {
    console.error("💥 Error al editar egreso:", error);
    throw error.response?.data || error;
  }
};


  // 📌 Eliminar
  const eliminarEgresoRME = async (id) => {
    try {
      const { data } = await api.delete(`/expenses/${id}`, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      return data;
    } catch (error) {
      console.error("💥 Error al eliminar egreso:", error);
      throw error.response?.data?.message || "Error al eliminar egreso";
    }
  };

   const descargarPdfEgreso = async (expenseId) => {
  try {
    const response = await api.get(
      `/expenses/${expenseId}/descargar-pdf`,
      {
        responseType: "blob", // 🔴 CLAVE
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }
    );

    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `egreso_${expenseId}.pdf`);
    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Error al descargar PDF:", error);
    alert("No se pudo descargar el documento");
  }
};

 const editarCuota = async (id,  estado) => {
    const { data } = await api.put(`/cuotas/${id}/estado`, {
    estado,
  });
  return data;
};

const descargarExcelExpenses = async (mes, anio, sucursal) => {
    try {
        const response = await api.get(
            "/expenses/export/excel",
            {
                params: {
                    mes,
                    anio,
                    sucursal,
                },
                responseType: "blob",
                headers: {
                    Authorization: `Bearer ${Token}`,
                },
            }
        );

        const url = window.URL.createObjectURL(
            new Blob([response.data])
        );

        const link = document.createElement("a");
        link.href = url;
        link.download = `Egresos_${new Date()
            .toISOString()
            .slice(0, 10)}.xlsx`;

        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);

    } catch (error) {
        console.error(error);
        throw (
            error?.response?.data?.message ||
            "Error al descargar Excel"
        );
    }
};

  return {
    getEgresos,
    getEgresoById,
    crearEgresoRME,
    editarEgresoRME,
    eliminarEgresoRME,
    descargarPdfEgreso,
    editarCuota,
    descargarExcelExpenses
  };
};



export const useEgresoSumaRME = () => {
  const { Token } = useUserSuperEmpresa();

  // 👉 Suma total del mes actual
  const getSumaMesActual = async () => {
    const { data } = await api.get("/expenses/sumas/ultimo-mes", {
      headers: { Authorization: `Bearer ${Token}` },
    });
    return data;
  };

  // 👉 Suma total del mes actual por branch
  const getSumaMesActualPorBranch = async () => {
    const { data } = await api.get(`/expenses/sucursal/sumas/ultimo-mes`, {
      headers: { Authorization: `Bearer ${Token}` },
    });
    return data;
  };

  // 👉 Suma por mes y año
  const getSumaPorMesAnio = async () => {
    const { data } = await api.get(`/expenses/sumas/meses-anteriores`, {
      headers: { Authorization: `Bearer ${Token}` },
    });
    return data;
  };

  // 👉 Suma por mes, año y branch
  const getSumaPorMesAnioBranch = async () => {
    const { data } = await api.get(
      `/expenses/sucursal/sumas/meses-anteriores`,
      { headers: { Authorization: `Bearer ${Token}` } }
    );
    return data;
  };

  return {
    getSumaMesActual,
    getSumaMesActualPorBranch,
    getSumaPorMesAnio,
    getSumaPorMesAnioBranch,
  };
};



export const useExpenseCategoryRME = () => {
  const { Token } = useUserSuperEmpresa();

  const getCategorias = async () => {
    const { data } = await api.get("/expenses/categories", {
      headers: { Authorization: `Bearer ${Token}` },
    });
    return data;
  };

  const getCategoriaById = async (id) => {
    const { data } = await api.get(`/expenses/categories/${id}`, {
      headers: { Authorization: `Bearer ${Token}` },
    });
    return data;
  };

  const crearCategoria = async (categoria) => {
    const { data } = await api.post(`/expenses/categories`, categoria, {
      headers: { Authorization: `Bearer ${Token}` },
    });
    return data;
  };

  const editarCategoria = async (id, categoria) => {
    const { data } = await api.put(`/expenses/edit/categories/${id}`, categoria, {
      headers: { Authorization: `Bearer ${Token}` },
    });
    return data;
  };

  const eliminarCategoria = async (id) => {
    const { data } = await api.delete(`/expenses/categories/${id}`, {
      headers: { Authorization: `Bearer ${Token}` },
    });
    return data;
  };

  

  return {
    getCategorias,
    getCategoriaById,
    crearCategoria,
    editarCategoria,
    eliminarCategoria,
   
  };
};


    /* funciones de traer */
export const useGetEgresosRME = () => {
    const { Token } = useUserSuperEmpresa();
    const { getEgresos } = useEgresoRME();

    const [egresosrme, setEgresosRme] = useState([]);
    const [loadingEgresos, setLoadingEgresos] = useState(false);
    const [error, setError] = useState(null);

    const fetchEgresosRME = async (
        mes = "",
        anio = "",
        tipoFecha = "date",
        categoria =""
    ) => {
        setLoadingEgresos(true);

        try {
            const data = await getEgresos(
                mes,
                anio,
                tipoFecha,
                categoria
            );

            setEgresosRme(data);

        } catch (err) {
            setError(
                err.response?.data?.message ||
                "Error al obtener egresos"
            );
        } finally {
            setLoadingEgresos(false);
        }
    };

    // Cargar automáticamente el último período
    useEffect(() => {
        if (Token) {
            fetchEgresosRME();
        }
    }, [Token]);

    return {
        egresosrme,
        loadingEgresos,
        error,
        refetch: fetchEgresosRME
    };
};
    export const useGetCategoriasRME = () => {
  const { Token } = useUserSuperEmpresa();
  const { getCategorias } = useExpenseCategoryRME();
  const [categorias, setCategorias] = useState([]);
  const [loadingCategorias, setLoadingCategorias] = useState(false);
  const [errorcategoria, setError] = useState(null);

  const fetchCategorias = async () => {
    setLoadingCategorias(true);
    try {
      const data = await getCategorias();
      setCategorias(data);
    } catch (err) {
      setError(err);
    } finally {
      setLoadingCategorias(false);
    }
  };

  useEffect(() => {
    if (Token) fetchCategorias();
  }, [Token]);

  return { categorias, loadingCategorias, errorcategoria, refetchcategoria: fetchCategorias };
};

export const useGetSumaMesActual = () => {
  const { Token } = useUserSuperEmpresa();
  const { getSumaMesActual } = useEgresoSumaRME();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchSuma = async () => {
    setLoading(true);
    try {
      const respuesta = await getSumaMesActual();
      setData(respuesta);
    } catch (err) {
      setError(err?.message || "Error al obtener la suma del mes actual");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (Token) fetchSuma();
  }, [Token]);

  return { data, loading, error, refetch: fetchSuma };
};


export const useGetSumaMesActualPorBranch = (branchId) => {
  const { Token } = useUserSuperEmpresa();
  const { getSumaMesActualPorBranch } = useEgresoSumaRME();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchSuma = async () => {
    if (!branchId) return; // evita llamadas vacías
    setLoading(true);
    try {
      const respuesta = await getSumaMesActualPorBranch(branchId);
      setData(respuesta);
    } catch (err) {
      setError(err?.message || "Error al obtener suma del mes por branch");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (Token && branchId) fetchSuma();
  }, [Token, branchId]);

  return { data, loading, error, refetch: fetchSuma };
};


export const useGetSumaPorMesAnio = (mes, year) => {
  const { Token } = useUserSuperEmpresa();
  const { getSumaPorMesAnio } = useEgresoSumaRME();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchSuma = async () => {
    if (!mes || !year) return;
    setLoading(true);
    try {
      const respuesta = await getSumaPorMesAnio(mes, year);
      setData(respuesta);
    } catch (err) {
      setError(err?.message || "Error al obtener suma por mes y año");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (Token && mes && year) fetchSuma();
  }, [Token, mes, year]);

  return { data, loading, error, refetch: fetchSuma };
};


/* get suma por mes año y sucursal  */
export const useGetSumaPorMesAnioBranch = (mes, year, branchId) => {
  const { Token } = useUserSuperEmpresa();
  const { getSumaPorMesAnioBranch } = useEgresoSumaRME();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchSuma = async () => {
    if (!mes || !year || !branchId) return;
    setLoading(true);
    try {
      const respuesta = await getSumaPorMesAnioBranch(mes, year, branchId);
      setData(respuesta);
    } catch (err) {
      setError(err?.message || "Error al obtener suma filtrada");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (Token && mes && year && branchId) fetchSuma();
  }, [Token, mes, year, branchId]);

  return { data, loading, error, refetch: fetchSuma };
};



export const useEgresoProveedoresRME = () => {
  const { Token } = useUserSuperEmpresa();

  const [proveedores, setProveedores] = useState([]);
  const [loadingProveedores, setLoading] = useState(false);
  const [errorProveedores, setError] = useState(null);

  const getProveedores = async () => {
    setLoading(true);
    setError(null);

    try {
      const { data } = await api.get("/proveedores", {
        headers: { Authorization: `Bearer ${Token}` },
      });

      setProveedores(data);
      return data;

    } catch (error) {
      const msg =
        error.response?.data?.message || "Error al cargar proveedores";

      setError(msg);
      console.error("ERROR proveedores:", msg);
      throw msg;

    } finally {
      setLoading(false);
    }
  };

  // cargar automáticamente apenas se use el hook
  useEffect(() => {
    getProveedores();
  }, []);

  return {
    proveedores,
    loadingProveedores,
    errorProveedores,
    refetchProveedores: getProveedores,
  };
};


export const useRemuneracionesEgresos = () => {
  const [egresosremu, setEgresos] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const cargarRemuneraciones = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await api.get("/expenses/remuneraciones/todos");

      setEgresos(response.data.data || []);
      setTotal(response.data.total_monto || 0);

    } catch (err) {
      console.error("Error al cargar remuneraciones", err);
      setError("No se pudieron cargar las remuneraciones");
    } finally {
      setLoading(false);
    }
  };

  return {
    egresosremu,
    total,
    loading,
    error,
    cargarRemuneraciones,
  };
};


